module.exports = function (WaveformData, webaudioBuilder, WaveformOverview, WaveformZoomView, WaveformSegments, WaveformPoints, Utils) {
    'use strict';
    var isXhr2 = 'withCredentials' in new XMLHttpRequest();
    function Waveform(peaks) {
        this.peaks = peaks;
    }
    Waveform.prototype.init = function (ui) {
        this.ui = ui;
        this.onResize = this.onResize.bind(this);
        this._getRemoteData(this.peaks.options);
    };
    Waveform.prototype._getRemoteData = function (options) {
        if (options.dataUri && options.audioContext) {
            throw new Error('Peaks.init(): You must pass an audioContext or dataUri to render waveform data, not both');
        } else if (options.dataUri) {
            return this._getRemoteWaveformData(options);
        } else if (options.audioContext) {
            return this._buildWaveformDataUsingWebAudio(options);
        } else {
            throw new Error('Peaks.init(): You must pass an audioContext or dataUri to render waveform data');
        }
    };
    Waveform.prototype._getRemoteWaveformData = function (options) {
        var self = this;
        var dataUri = null;
        var requestType = null;
        var url;
        if (Utils.isObject(options.dataUri)) {
            dataUri = options.dataUri;
        } else if (Utils.isString(options.dataUri)) {
            dataUri = {};
            dataUri[options.dataUriDefaultFormat || 'json'] = options.dataUri;
        } else {
            throw new Error('Peaks.init(): The dataUri option must be an object');
        }
        [
            'ArrayBuffer',
            'JSON'
        ].some(function (connector) {
            if (window[connector]) {
                requestType = connector.toLowerCase();
                url = dataUri[requestType];
                return Boolean(url);
            }
        });
        if (!url) {
            throw new Error('Peaks.init(): Unable to determine a compatible dataUri format for this browser');
        }
        var xhr = self._createXHR(url, requestType, function (response) {
            if (this.readyState !== 4) {
                return;
            }
            if (this.status !== 200) {
                self._handleRemoteData(new Error('Unable to fetch remote data. HTTP status ' + this.status));
                return;
            }
            self._handleRemoteData(null, response.target, xhr);
        });
        xhr.send();
    };
    Waveform.prototype._buildWaveformDataUsingWebAudio = function (options) {
        var self = this;
        if (!(options.audioContext instanceof AudioContext)) {
            throw new TypeError('Peaks.init(): The audioContext option must be a valid AudioContext');
        }
        if (options.waveformBuilderOptions.scale !== options.zoomLevels[0]) {
            options.waveformBuilderOptions.scale = options.zoomLevels[0];
        }
        var mediaSourceUrl = self.peaks.player.getCurrentSource();
        if (mediaSourceUrl) {
            self._requestAudioAndBuildWaveformData(mediaSourceUrl, options.audioContext, options.waveformBuilderOptions);
        } else {
            self.peaks.on('player_canplay', function (player) {
                self._requestAudioAndBuildWaveformData(player.getCurrentSource(), options.audioContext, options.waveformBuilderOptions);
            });
        }
    };
    Waveform.prototype._requestAudioAndBuildWaveformData = function (url, audioContext, waveformBuilderOptions) {
        var self = this;
        if (!url) {
            self.peaks.logger('Peaks.init(): The mediaElement src is invalid');
            return;
        }
        var xhr = self._createXHR(url, 'arraybuffer', function (response) {
            if (this.readyState !== 4) {
                return;
            }
            if (this.status !== 200) {
                self._handleRemoteData(new Error('Unable to fetch remote data. HTTP status ' + this.status));
                return;
            }
            webaudioBuilder(audioContext, response.target.response, waveformBuilderOptions, self._handleRemoteData.bind(self));
        });
        xhr.send();
    };
    Waveform.prototype._createXHR = function (url, requestType, onLoad) {
        var self = this;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        if (isXhr2) {
            try {
                xhr.responseType = requestType;
            } catch (e) {
            }
        }
        xhr.onload = onLoad;
        xhr.onerror = function (err) {
            setTimeout(function () {
                self.peaks.emit('error', new Error('XHR Failed'));
            }, 0);
        };
        if (isXhr2 && this.peaks.options.withCredentials) {
            xhr.withCredentials = true;
        }
        return xhr;
    };
    Waveform.prototype._handleRemoteData = function (err, remoteData, xhr) {
        if (err) {
            this.peaks.emit('error', err);
            return;
        }
        this.originalWaveformData = null;
        try {
            this.originalWaveformData = remoteData instanceof WaveformData ? remoteData : WaveformData.create(remoteData);
            this.waveformOverview = new WaveformOverview(this.originalWaveformData, this.ui.overview, this.peaks);
            this.waveformZoomView = new WaveformZoomView(this.originalWaveformData, this.ui.zoom, this.peaks);
            this.peaks.emit('segments.ready');
            this.peaks.emit('peaks.ready');
        } catch (e) {
            this.peaks.emit('error', e);
            return;
        }
        this._bindEvents();
    };
    Waveform.prototype._bindEvents = function () {
        var self = this;
        self.peaks.on('user_seek', function (time) {
            self.peaks.player.seek(time);
        });
        window.addEventListener('resize', self.onResize);
    };
    Waveform.prototype.destroy = function () {
        if (this.waveformOverview) {
            this.waveformOverview.destroy();
            this.waveformOverview = null;
        }
        if (this.waveformZoomView) {
            this.waveformZoomView.destroy();
            this.waveformZoomView = null;
        }
        window.removeEventListener('resize', this.onResize);
        if (this.resizeTimeoutId) {
            clearTimeout(this.resizeTimeoutId);
            this.resizeTimeoutId = null;
        }
    };
    Waveform.prototype.onResize = function () {
        var self = this;
        self.peaks.emit('window_resize');
        if (self.resizeTimeoutId) {
            clearTimeout(self.resizeTimeoutId);
        }
        self.resizeTimeoutId = setTimeout(function () {
            var width = self.ui.player.clientWidth;
            self.peaks.emit('window_resize_complete', width);
        }, 500);
    };
    return Waveform;
}(require('waveform-data'), require('waveform-data/webaudio'), require('peaks/views/waveform.overview'), require('peaks/views/waveform.zoomview'), require('peaks/markers/waveform.segments'), require('peaks/markers/waveform.points'), require('peaks/waveform/waveform.utils'));